import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// 引入字体
require('@/assets/fonts/font.css')

// 引入mock
// import './mock/index.js'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
